.form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

/* Fiscal codes are written in capitals; showing them so while typing matches
 * what the service stores. */
.form input {
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
